export const createStyleSheet = <K extends string>(
    styles: Record<K, React.CSSProperties>,
) => styles
